import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'reducers/store'

const selectedAudienceProfilerKPI = (state: Pick<RootState, 'audienceProfiler'>) =>
  state.audienceProfiler.selectedKPI

export const getSegmentVisibility = (state: RootState) => state.audienceProfiler.segmentVisibility

export const getSelectedAudienceProfilerKPI = createSelector(
  selectedAudienceProfilerKPI,
  (selectedKPI) => {
    return selectedKPI
  }
)

export const getNavigateBackBarVisible = (state: RootState) =>
  state.audienceProfiler.navigateBackBarVisible.visible

export const getNavigateBackBarRootPage = (state: RootState) =>
  state.audienceProfiler.navigateBackBarVisible.fromPage

export const getBubbleExportVisible = (state: RootState) =>
  state.audienceProfiler.bubbleExportVisible
